export const servicesData = {
  "clear-aligner-treatment-planning": {
    title: "Clear Aligner Treatment Planning",
    subTitle:
      "Advanced digital treatment planning for clear aligner cases with precise tooth movement simulations.",
    imgUrl: "/images/departments/Clear Aligner Treatment Planning.png",
  },

  "orthodontic-cad-design-services": {
    title: "Orthodontic CAD Design Services",
    subTitle:
      "Professional CAD design solutions for orthodontic appliances and treatment workflows.",
    imgUrl: "/images/departments/Orthodontic CAD Design Services.png",
  },

  "fixed-and-removable-retainer-design": {
    title: "Fixed and Removable Retainer Design",
    subTitle:
      "Custom retainer design services for long-term orthodontic retention.",
    imgUrl: "/images/departments/Fixed and Removable Retainer Design.png",
  },

  "sleep-apnea-mad-device-design": {
    title: "Sleep Apnea & MAD Device Design",
    subTitle:
      "Custom mandibular advancement device design for sleep apnea treatment.",
    imgUrl: "/images/departments/Sleep Apnea & MAD Device Design.png",
  },

  "surgical-guide-design-for-implantology": {
    title: "Surgical Guide Design for Implantology",
    subTitle:
      "Precise implant planning and surgical guide design services.",
    imgUrl: "/images/departments/Surgical Guide Design for Implantology.png",
  },

  "digital-model-analysis-and-setup": {
    title: "Digital Model Analysis and Setup",
    subTitle:
      "Comprehensive digital model analysis and virtual setup services.",
    imgUrl: "/images/departments/Digital Model Analysis and Setup.png",
  },

  "3d-orthodontic-treatment-simulation": {
    title: "3D Orthodontic Treatment Simulation",
    subTitle:
      "Advanced 3D simulation of orthodontic treatment outcomes.",
    imgUrl: "/images/departments/3D Orthodontic Treatment Simulation.png",
  },

  "cad-cam-workflow-consultation": {
    title: "CAD/CAM Workflow Consultation",
    subTitle:
      "Expert CAD/CAM workflow optimization and consultation services.",
    imgUrl: "/images/departments/CADCAM Workflow Consultation.png",
  },
};